//@ts-check
import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';

var Loading = function Loading(_ref) {
  var title = _ref.title;
  return React.createElement("div", {
    style: {
      position: 'absolute',
      bottom: '50%',
      left: 0,
      right: 0,
      textAlign: 'center'
    }
  }, React.createElement(CircularProgress, {
    color: "secondary",
    size: 8 * 4
  }), React.createElement(Typography, null, title));
};

Loading.defaultProps = {
  title: 'Loading...'
};
export default Loading;